import React, { FC } from 'react'
import { observer } from 'mobx-react'
import { classNames } from '@dt/fe-utils'
import './index.scss'

// interface
type TProductItem = 'waterfall' | 'recommend' | 'classic' | 'list';
interface IProps {
  type?: TProductItem;
  className?: string;
  style?: any;
  lazy?: boolean;
  backgroundMode?: 'light' | 'dark';
  imgLoaded?: boolean;
  decorate?: TMealCommonDecorates;
  onClick?: () => void;
  id?: string;
}
// 瀑布流图片的宽度
const WaterfallItem: FC<IProps> = (props) => {
  const { style, id = '', onClick, className = '' } = props

  return (
    <div
      className={classNames(
        'product-item waterfall',
        className,
        // type,
        // {
        //   // 'product-shake': recommendShakeProduct && recommendShakeProduct?.no === product.no,
        //   'sold-out': soldout,
        // }
      )}
      style={style ? {
        visibility: style.left >= 0 ? 'visible' : 'hidden',
        left: style.left,
        top: style.top
      } : null}
      id={id}
      onClick={() => onClick()}
    >
      {props.children}
    </div>
  )
}
export default observer(WaterfallItem)
